export enum ParamName {
  Template = 'template',
  WalletAddress = 'walletAddress',
  StoryIndex = 'storyIndex',
  StoryId = 'storyId',
  TokenId = 'tokenId',
  Nft = 'nft',
  Ai = 'ai'
}
